// Copyright (c) 2023 WiseTime. All rights reserved.

import { Action } from "redux"
import { flatten, uniq } from "ramda"
import { getTagCategoriesIdsFromTimeline, getTagCategoriesIdsFromTimeRowsOrTimeGroups } from "../tags"
import * as TimelineSlice from "../../timeline/slices/timeline"
import * as TagsActions from "../actions"

export const getTagCategoryIdsList = (action: Action): string[] => {
  if (TimelineSlice.setTimeline.match(action)) {
    return uniq(flatten(action.payload.map(t => getTagCategoriesIdsFromTimeline(t))))
  }
  if (TimelineSlice.setTimeRowsForDates.match(action)) {
    return getTagCategoriesIdsFromTimeRowsOrTimeGroups(action.payload.timeRows)
  }
  if (TagsActions.batchGetTagCategories.match(action)) {
    return action.payload
  }
  return []
}
